<template>
    <div class="enter-cabiner-errors">
        <!--            Вывод системных ошибок регистрации если существуют-->
        <div v-if="authData.authInfo.errors" class="enter-cabinet__auth-errors">
            <span v-for="error in authData.authInfo.errors.system_errors">{{error}}</span>
        </div>
        <div v-else-if="authData.errors" class="enter-cabinet__auth-errors">
            <span v-for="error in authData.errors">{{error}}</span>
        </div>
        <!--        Вывод ошибок после реотправки кода на тел. для подтверждения регистрации если обнаружены -->
        <div v-if="authData.resendPhoneCodeData" class="register_error">
            <span v-if="authData.resendPhoneCodeData.status ==='error'"
                  v-for="error in authData.resendPhoneCodeData.errors">
                {{error.message}}
            </span>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
    name: 'enter-cabiner-errors',
    selector: '.enter-cabiner-errors',
    computed: {
        ...mapState({
            authData: ({ personal }) => personal.data,
        })
    },
    methods:{
        ...mapMutations({
            clearState: 'personal/clearState',
        }),
    },
    beforeDestroy() {
        this.clearState();
    }
}
</script>

<style lang="scss" scoped>
.enter-cabiner-errors{

}
</style>